import michelleImg from "../../images/Rectangle 24.png";
import lauraImg from "../../images/Rectangle 25.png";
import kenImg from "../../images/Rectangle 26.png";
import bretImg from "../../images/Rectangle 27.png";

export const advisoryCouncilMembers = [
  {
    id: 1,
    image: michelleImg,
    name: "Michelle Sims",
    description:
      "A passionate advocate for economic stability, women’s empowerment, and workplace equity, with deep roots in philanthropic and community development work.",
  },
  {
    id: 2,
    image: lauraImg,
    name: "Laura Youngblom",
    description:
      "A revenue-focused EdTech executive with 16+ years driving B2C and B2B growth across General Assembly, Emeritus, and beyond.",
  },
  {
    id: 3,
    image: kenImg,
    name: "Ken Ramirez",
    description:
      "A healthcare education CEO with deep expertise in e-learning, SaaS, and empowering clinicians through transformative professional development.",
  },
  {
    id: 4,
    image: bretImg,
    name: "Bret Sanders",
    description:
      "A competitive operator with a strong background in leadership, sales, business development, fundraising, and building high-performance teams.",
  },
];
